<template>
  <div>
    <div class="dashboard-title mb-lg">
      <div class="dashboard-title__actions">
        <div>
          <h1 class="fw-bold fs-xl mb-xs">Settings</h1>
          <p class="fc-darker fs-md mr-lg">
            Set up the main configuration of your directory.
          </p>
        </div>
        <Button v-on:button-click="saveChanges">
          Save Changes
          <!-- <i class="fa fa-save ml-sm"></i> -->
        </Button>
      </div>
    </div>
    <TabSelector :tabs="tabs"></TabSelector>
    <transition active="Profile" name="route">
      <router-view></router-view>
      <router-view name="categories"></router-view>
    </transition>
  </div>
</template>

<script>
import TabSelector from '@/components/Dashboard/TabSelector';
import Button from '@/components/DesignSystem/Button';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('directorySettings');

export default {
  components: {
    TabSelector,
    Button,
  },
  computed: {
    tabs() {
      return [
        {
          name: 'Profile',
          path: `/agency/our-directory/settings`,
        },
        {
          name: 'Categories',
          path: `/agency/our-directory/settings/categories`,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'saveChanges',
      'fetchDirectoryCategories',
      'fetchDirectorySettings',
      'fetchBranding',
    ]),
  },
  created() {
    this.fetchDirectoryCategories();
    this.fetchDirectorySettings();
    this.fetchBranding();
  },
};
</script>

<style lang="scss" scoped>
.route-enter-active,
.route-leave-active {
  transition-duration: 0.1s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.1s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
